<template>
    <v-container fluid grid-list-xl>
        <v-layout row wrap>
            <v-flex md6>
                <veggie-field type="broccoli" :rows="4" :cols="3" />
            </v-flex>
            <v-flex md6>
                <veggie-field type="pepper" :rows="6" :cols="4" />
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md4>
                <veggie-field type="carrot" :rows="9" :cols="2" />
            </v-flex>
            <v-flex md4>
                <veggie-field type="parsnip" :rows="9" :cols="3" />
            </v-flex>
            <v-flex md4>
                <veggie-field type="eggplant" :rows="9" :cols="3" />
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <veggie-field type="cucumber" :rows="2" :cols="3" />
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md4>
                <veggie-field type="tomato" :rows="2" :cols="2" />
            </v-flex>
            <v-flex md8>
                <veggie-field type="onion" :rows="2" :cols="5" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import VeggieField from './GridGarden/VeggieField'

export default {
    components: {
        VeggieField,
    },
}
</script>
